import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Tabs, Tab, Row, Col, Badge, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import moment from 'moment';
import { LOPDAOTAOLIENTUC_TRIENKHAI_HV_API } from '../../../utils/apiUrl';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { Get } from '../../../utils/httpProvider';

import StudentScheduleLienTucTab from './components/StudentScheduleLienTucTab';

const LopDaoTaoLienTucDetailHV = () => {
    const { id } = useParams();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('schedule');

    const { data: lopDetail, isLoading } = useQuery(
        ['lopDaoTaoLienTucDetailHV', id],
        () => Get(`${LOPDAOTAOLIENTUC_TRIENKHAI_HV_API.GET_ITEM}/${id}`),
        { 
            enabled: !!id,
            staleTime: 0,
            cacheTime: 0
        }
    );

    if (isLoading) {
        return <div className="p-4 text-center">Đang tải thông tin lớp học...</div>;
    }

    if (!lopDetail) {
        return (
            <div className="p-4 text-center">
                <h5>Không tìm thấy lớp đào tạo liên tục.</h5>
                <Button variant="info" onClick={() => history.push(URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_HV_PATH)}>
                    Quay lại danh sách
                </Button>
            </div>
        );
    }

    return (
        <div className="p-3">
            {/* Header thông tin lớp dành cho Học Viên */}
            <Card className="shadow-sm border-0 mb-3">
                <Card.Body>
                    <Row className="align-items-center">
                        <Col md={10}>
                            <div className="d-flex align-items-center mb-2">
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="mr-3"
                                    onClick={() => {
                                        if (window.history.length > 1) {
                                            history.goBack();
                                        } else {
                                            history.push(URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_HV_PATH);
                                        }
                                    }}
                                >
                                    <i className="fas fa-arrow-left mr-1"></i> Quay lại
                                </Button>
                                <h4 className="mb-0 text-info font-weight-bold">{lopDetail.tenKhoaHoc}</h4>
                                <Badge variant="info" className="ml-2 font-weight-normal px-2 py-1">
                                    <i className="fas fa-user-graduate mr-1"></i> Học viên
                                </Badge>
                            </div>
                            <div className="text-muted small">
                                <span className="mr-3">
                                    <i className="fas fa-file-alt mr-1"></i>
                                    Số QĐ: <strong>{lopDetail.soQuyetDinh || "Chưa có"}</strong>
                                </span>
                                <span className="mr-3">
                                    <i className="fas fa-calendar-alt mr-1"></i>
                                    Khai giảng: <strong>{lopDetail.ngayKhaiGiang ? moment(lopDetail.ngayKhaiGiang).format('DD/MM/YYYY') : "—"}</strong>
                                </span>
                                <span className="mr-3">
                                    <i className="fas fa-calendar-check mr-1"></i>
                                    Bế giảng: <strong>{lopDetail.ngayBeGiang ? moment(lopDetail.ngayBeGiang).format('DD/MM/YYYY') : "—"}</strong>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Tabs nghiệp vụ Học Viên */}
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="custom-nav-tabs mb-3">
                <Tab
                    eventKey="schedule"
                    title={
                        <span>
                            <i className="fas fa-calendar-alt mr-1"></i> Thời Khóa Biểu & Lịch Học Cá Nhân
                        </span>
                    }
                >
                    <StudentScheduleLienTucTab lopId={id} />
                </Tab>
            </Tabs>
        </div>
    );
};

export default LopDaoTaoLienTucDetailHV;
